export default "__VITE_ASSET__DfavPxAo__ 100w";